import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, Badge } from "../AdminUI";
import { Check, Clock } from "lucide-react";
import { toast } from "sonner";

export default function Checklist() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/checklist").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (item) => {
    try { await api.patch(`/admin/checklist/${item.id}`, { done: !item.done }); load(); }
    catch { toast.error("Failed"); }
  };

  const confirmed = items.filter((i) => i.done);
  const pending = items.filter((i) => !i.done);

  const Row = ({ i }) => (
    <button onClick={() => toggle(i)} data-testid={`checklist-${i.id}`}
      className="w-full flex items-center gap-3 py-2.5 px-2 -mx-2 rounded hover:bg-gray-50 text-left">
      <span className={`h-5 w-5 rounded-md flex items-center justify-center shrink-0 ${i.done ? "bg-green-500 text-white" : "border-2 border-gray-300"}`}>
        {i.done && <Check className="w-3.5 h-3.5" />}
      </span>
      <span className={`text-sm ${i.done ? "text-gray-500 line-through" : "text-[var(--navy)] font-medium"}`}>{i.item}</span>
    </button>
  );

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-head font-extrabold text-3xl text-[var(--navy)] uppercase tracking-tight">Setup Checklist</h1>
        <p className="text-gray-500 text-sm">Track what's confirmed and what's still pending. Changes are saved automatically.</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card title={`Confirmed (${confirmed.length})`} action={<Badge color="green">Done</Badge>}>
          {confirmed.map((i) => <Row key={i.id} i={i} />)}
        </Card>
        <Card title={`Pending (${pending.length})`} action={<Badge color="amber">To confirm</Badge>}>
          {pending.map((i) => <Row key={i.id} i={i} />)}
        </Card>
      </div>
    </div>
  );
}
